/**
 * Aggiunge giorni utili (escludendo sabato e domenica) a una data
 * @param {Date} date - Data di partenza
 * @param {number} days - Numero di giorni utili da aggiungere
 * @returns {Date} - Nuova data con i giorni utili aggiunti
 */
export function addBusinessDays(date, days) {
  const result = new Date(date)
  let addedDays = 0
  
  while (addedDays < days) {
    result.setDate(result.getDate() + 1)
    
    // Ottieni il giorno della settimana (0 = domenica, 6 = sabato)
    const dayOfWeek = result.getDay()
    
    // Se non è sabato (6) né domenica (0), conta come giorno utile
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      addedDays++
    }
  }
  
  return result
}

/**
 * Calcola il numero di giorni utili tra due date (escludendo sabato e domenica)
 * @param {Date} startDate - Data di inizio
 * @param {Date} endDate - Data di fine
 * @returns {number} - Numero di giorni utili
 */
export function calculateBusinessDays(startDate, endDate) {
  // Crea copie delle date per non modificare gli originali
  const start = new Date(startDate)
  const end = new Date(endDate)
  
  // Reset delle ore per confronto accurato
  start.setHours(0, 0, 0, 0)
  end.setHours(0, 0, 0, 0)
  
  // Se le date sono uguali, ritorna 0
  if (start.getTime() === end.getTime()) {
    return 0
  }
  
  // Se la data di fine è prima della data di inizio, ritorna 0
  if (end < start) {
    return 0
  }
  
  let businessDays = 0
  const current = new Date(start)
  
  // Inizia dal giorno successivo alla data di inizio
  current.setDate(current.getDate() + 1)
  
  // Itera attraverso ogni giorno tra start e end (escludendo start, includendo end)
  while (current <= end) {
    const dayOfWeek = current.getDay()
    
    // Se non è sabato (6) né domenica (0), conta come giorno utile
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDays++
    }
    
    current.setDate(current.getDate() + 1)
  }
  
  return businessDays
}

/**
 * Verifica se una data è un giorno utile (non sabato né domenica)
 * @param {Date} date - Data da verificare
 * @returns {boolean} - True se è un giorno utile
 */
export function isBusinessDay(date) {
  const dayOfWeek = date.getDay()
  return dayOfWeek !== 0 && dayOfWeek !== 6
}
